<template>
  <div class="page">
    <top-header></top-header>

    <b-container fluid class="rtc-page">
      <b-row class="mb-3 align-items-center">
        <b-col>
          <h3 class="mb-0">RTC Records</h3>
          <small class="text-muted">Total records: {{ records.length }}</small>
        </b-col>
        <b-col cols="auto">
          <!-- <b-button
            size="sm"
            variant="primary"
            class="mr-2"
            :disabled="selectedImeis.length === 0 || settingRTC"
            @click="setRTC"
          >
            <b-spinner v-if="settingRTC" small class="mr-1"></b-spinner>
            SET RTC ({{ selectedImeis.length }})
          </b-button> -->
          <b-button size="sm" variant="outline-primary" @click="initload" :disabled="loading || settingRTC">
            <b-spinner v-if="loading" small class="mr-1"></b-spinner>
            Refresh
          </b-button>
        </b-col>
      </b-row>

      <b-card class="mb-3">
        <b-row>
          <b-col md="4" sm="6" class="mb-2">
            <label for="searchInput">Search Feeder Pillar / IMEI</label>
            <b-input-group size="sm">
              <b-form-input
                id="searchInput"
                v-model.trim="searchText"
                placeholder="Enter feeder pillar number or IMEI"
              ></b-form-input>
              <b-input-group-append>
                <b-button variant="outline-secondary" :disabled="!searchText" @click="searchText = ''">
                  Clear
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-col>

          <b-col md="3" sm="6" class="mb-2">
            <label for="connectionFilter">Connection Status</label>
            <b-form-select
              id="connectionFilter"
              v-model="connectionFilter"
              :options="connectionOptions"
              size="sm"
            ></b-form-select>
          </b-col>

          <b-col md="3" sm="6" class="mb-2">
            <label for="rtcFilter">RTC Status</label>
            <b-form-select
              id="rtcFilter"
              v-model="rtcFilter"
              :options="rtcOptions"
              size="sm"
            ></b-form-select>
          </b-col>

          <b-col md="2" sm="6" class="mb-2 d-flex align-items-end">
            <b-button block size="sm" variant="outline-danger" @click="clearFilters">
              Reset Filters
            </b-button>
          </b-col>
        </b-row>

       <!--  <b-row class="mt-2">
          <b-col>
            <b-badge variant="info" class="mr-2">Selected: {{ selectedImeis.length }}</b-badge>
            <b-badge variant="success" class="mr-2">Connected: {{ connectedCount }}</b-badge>
            <b-badge variant="danger" class="mr-2">Disconnected: {{ disconnectedCount }}</b-badge>
            <b-badge variant="success" class="mr-2">RTC Correct: {{ rtcCorrectCount }}</b-badge>
            <b-badge variant="warning">RTC Incorrect: {{ rtcIncorrectCount }}</b-badge>
          </b-col>
        </b-row> -->
      </b-card>

      <div class="container-box">
        <b-row class="mt-4 px-3 align-items-center">
          <b-col cols="auto">
            <span class="mr-2">Show</span>
            <b-form-select
              v-model="perPage"
              :options="pageOptions"
              size="sm"
              class="page-size-select"
            ></b-form-select>
            <span class="ml-2">entries</span>
          </b-col>
          <b-col class="text-right">
            <small class="text-muted">
              Showing {{ filteredRecords.length ? ((currentPage - 1) * perPage + 1) : 0 }}
              to {{ Math.min(currentPage * perPage, filteredRecords.length) }}
              of {{ filteredRecords.length }} entries
            </small>
          </b-col>
        </b-row>

        <b-row class="px-3 pt-3">
          <b-col lg="12">
            <b-table
          id="rtc-table"
          show-empty
          sticky-header
          small
          striped
          outlined
          stacked="md"
          :busy="loading"
          :items="filteredRecords"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          empty-text="No RTC records found"
        >
          <template v-slot:head(select)>
            <b-form-checkbox
              :checked="allFilteredSelected"
              :indeterminate="someFilteredSelected && !allFilteredSelected"
              :disabled="filteredRecords.length === 0"
              @change="selectAllFiltered"
              aria-label="Select all filtered records"
            ></b-form-checkbox>
          </template>

          <template v-slot:cell(select)="row">
            <b-form-checkbox
              :checked="isSelected(row.item.imei_no)"
              @change="toggleSelection(row.item.imei_no, $event)"
              aria-label="Select this device"
            ></b-form-checkbox>
          </template>

          <template v-slot:cell(supply)="row">
            {{ row.value === null || row.value === undefined ? '-' : row.value }}
          </template>

          <template v-slot:cell(connection_status)="row">
            <b-badge :variant="row.value === 'CONNECTED' ? 'success' : 'danger'">
              {{ row.value || 'UNKNOWN' }}
            </b-badge>
          </template>

          <template v-slot:cell(data_status)="row">
            <b-badge :variant="row.value === 'DATA RECEIVED' ? 'success' : 'warning'">
              {{ row.value || 'UNKNOWN' }}
            </b-badge>
          </template>

          <template v-slot:cell(rtc_status)="row">
            <b-badge
              :variant="row.value === 'RTC CORRECT' ? 'success' : (row.value === 'RTC INCORRECT' ? 'danger' : 'secondary')"
            >
              {{ row.value || 'UNKNOWN' }}
            </b-badge>
          </template>

          <template v-slot:cell(rtc_difference_minutes)="row">
            {{ row.value === null || row.value === undefined ? '-' : row.value + ' min' }}
          </template>

          <template v-slot:table-busy>
            <div class="text-center text-primary my-3">
              <b-spinner class="align-middle mr-2"></b-spinner>
              <strong>Loading RTC records...</strong>
            </div>
          </template>
            </b-table>
          </b-col>
        </b-row>

        <b-row class="px-3">
          <b-col lg="6">
            <span class="mr-2">
              Showing {{ filteredRecords.length ? ((currentPage - 1) * perPage + 1) : 0 }}
              to {{ Math.min(currentPage * perPage, filteredRecords.length) }}
              of {{ filteredRecords.length }} entries
            </span>
          </b-col>
          <b-col lg="6">
            <b-pagination
              v-if="filteredRecords.length"
              v-model="currentPage"
              :total-rows="filteredRecords.length"
              :per-page="perPage"
              pills
              align="right"
              size="sm"
              prev-text="Prev"
              next-text="Next"
              first-number
              last-number
            ></b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";

export default {
  name: "Rtu",
  components: {
    "top-header": Header
  },

  data() {
    return {
      recordUrl: this.$session.get("apiurl") + "esmartapi/get-rtc-list",
      records: [],
      loading: false,
      selectedImeis: [],
      settingRTC: false,
      setRtcUrl: this.$session.get("apiurl") + "esmartapi/set-rtc",

      searchText: "",
      connectionFilter: "",
      rtcFilter: "",

      currentPage: 1,
      perPage: 50,
      pageOptions: [
        { value: 10, text: "10" },
        { value: 20, text: "20" },
        { value: 50, text: "50" },
        { value: 100, text: "100" },
        { value: 250, text: "250" },
        { value: 500, text: "500" }
      ],

      sortBy: "update_time",
      sortDesc: true,

      connectionOptions: [
        { value: "", text: "All Connection Statuses" },
        { value: "CONNECTED", text: "CONNECTED" },
        { value: "DISCONNECTED", text: "DISCONNECTED" }
      ],

      rtcOptions: [
        { value: "", text: "All RTC Statuses" },
        { value: "RTC CORRECT", text: "RTC CORRECT" },
        { value: "RTC INCORRECT", text: "RTC INCORRECT" },
        { value: "RTC NOT AVAILABLE", text: "RTC NOT AVAILABLE" }
      ],

      fields: [
        /* { key: "select", label: "", sortable: false, thClass: "text-center", tdClass: "text-center" },*/
        /*  { key: "imei_no", label: "IMEI Number", sortable: true, thClass: "text-nowrap" },  */
        { key: "feeder_pillar_no", label: "Feeder Pillar", sortable: true },
        { key: "data_stamp", label: "RTC / Data Stamp", sortable: true, thClass: "text-nowrap",
			formatter: (value) => {
						return this.$moment(value).format('DD-MM-YYYY HH:mm');
					}
		 },
      /*   { key: "supply", label: "Supply", sortable: true, tdClass: "text-center" }, */
        /* { key: "update_time", label: "Last Update", sortable: true, thClass: "text-nowrap" }, */
        { key: "connection_status", label: "Connection", sortable: true },
        /* { key: "data_status", label: "Data Status", sortable: true }, */
        { key: "rtc_status", label: "RTC Status", sortable: true },
        { key: "rtc_difference_minutes", label: "RTC Difference", sortable: true }
      ]
    };
  },

  computed: {
    filteredRecords() {
      const search = this.searchText.toLowerCase();

      return this.records.filter(record => {
        const matchesSearch =
          !search ||
          String(record.feeder_pillar_no || "").toLowerCase().includes(search) ||
          String(record.imei_no || "").toLowerCase().includes(search);

        const matchesConnection =
          !this.connectionFilter ||
          record.connection_status === this.connectionFilter;

        const matchesRtc =
          !this.rtcFilter ||
          record.rtc_status === this.rtcFilter;

        return matchesSearch && matchesConnection && matchesRtc;
      });
    },

    allFilteredSelected() {
      return this.filteredRecords.length > 0 &&
        this.filteredRecords.every(record => this.isSelected(record.imei_no));
    },

    someFilteredSelected() {
      return this.filteredRecords.some(record => this.isSelected(record.imei_no));
    },

    connectedCount() {
      return this.records.filter(row => row.connection_status === "CONNECTED").length;
    },

    disconnectedCount() {
      return this.records.filter(row => row.connection_status === "DISCONNECTED").length;
    },

    rtcCorrectCount() {
      return this.records.filter(row => row.rtc_status === "RTC CORRECT").length;
    },

    rtcIncorrectCount() {
      return this.records.filter(row =>
        row.rtc_status === "RTC INCORRECT" ||
        row.rtc_status === "RTC NOT AVAILABLE"
      ).length;
    }
  },

  watch: {
    searchText() {
      this.currentPage = 1;
    },
    connectionFilter() {
      this.currentPage = 1;
    },
    rtcFilter() {
      this.currentPage = 1;
    },
    perPage() {
      this.currentPage = 1;
    }
  },

  mounted() {
    this.initload();
  },

  methods: {
    initload() {
      this.loading = true;

      this.axios.post(this.recordUrl, {
        accesskey: this.$session.get("access_key")
      })
        .then(response => {
          if (response.data && (response.data.error === 0 || response.data.error === "0")) {
            this.records = Array.isArray(response.data.result) ? response.data.result : [];
          } else {
            this.records = [];
            this.$bvToast.toast(
              (response.data && response.data.message) || "Unable to fetch RTC records.",
              {
                title: "RTC Records",
                variant: "warning",
                solid: true,
                autoHideDelay: 5000
              }
            );
          }
        })
        .catch(error => {
          console.error("RTC records API error:", error);
          this.records = [];
          this.$bvToast.toast("Unable to load RTC records. Please try again.", {
            title: "API Error",
            variant: "danger",
            solid: true,
            autoHideDelay: 5000
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    isSelected(imei) {
      return this.selectedImeis.includes(String(imei));
    },

    toggleSelection(imei, checked) {
      const value = String(imei);
      if (!value || value === "undefined" || value === "null") return;

      if (checked) {
        if (!this.selectedImeis.includes(value)) this.selectedImeis.push(value);
      } else {
        this.selectedImeis = this.selectedImeis.filter(item => item !== value);
      }
    },

    selectAllFiltered(checked) {
      const visibleImeis = this.filteredRecords
        .map(record => String(record.imei_no || ""))
        .filter(imei => imei && imei !== "undefined" && imei !== "null");

      if (checked) {
        this.selectedImeis = Array.from(new Set(this.selectedImeis.concat(visibleImeis)));
      } else {
        this.selectedImeis = this.selectedImeis.filter(imei => !visibleImeis.includes(imei));
      }
    },

    setRTC() {
      if (!this.selectedImeis.length || this.settingRTC) return;

      const confirmed = window.confirm(
        `Are you sure you want to send SET RTC command to ${this.selectedImeis.length} selected device(s)?`
      );
      if (!confirmed) return;

      this.settingRTC = true;
      this.axios.post(this.setRtcUrl, {
        accesskey: this.$session.get("access_key"),
        imei_no: this.selectedImeis.slice()
      })
        .then(response => {
          const data = response.data || {};
          const success = data.error === 0 || data.error === "0";

          this.$bvToast.toast(
            data.message || (success ? "SET RTC command sent successfully." : "Unable to send SET RTC command."),
            {
              title: success ? "SET RTC" : "SET RTC Failed",
              variant: success ? "success" : "danger",
              solid: true,
              autoHideDelay: 5000
            }
          );

          if (success) {
            this.selectedImeis = [];
            this.initload();
          }
        })
        .catch(error => {
          console.error("SET RTC API error:", error);
          this.$bvToast.toast("Unable to send SET RTC command. Please try again.", {
            title: "API Error",
            variant: "danger",
            solid: true,
            autoHideDelay: 5000
          });
        })
        .finally(() => {
          this.settingRTC = false;
        });
    },

    clearFilters() {
      this.searchText = "";
      this.connectionFilter = "";
      this.rtcFilter = "";
      this.currentPage = 1;
    }
  }
};
</script>

<style scoped>
.rtc-page {
  margin-top: 5%;
}

.page-size-select {
  width: 85px;
  display: inline-block;
}

label {
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 5px;
}

.table {
  font-size: 12px;
}

.table td,
.table th {
  vertical-align: middle;
}

.container-box {
  background: #fff;
  padding: 15px 0;
  border-radius: 4px;
}
</style>
